import {
  CardDefinition,
  CAROUSEL,
  CAROUSEL_NEXT,
  CarouselDefinition,
  CarouselNextDefinition
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Cards8: Translator = sequence => {
  const cards: CardDefinition[] = [];
  const header: { title: string; subtitle: string; icon: string } = {
    title: '',
    subtitle: '',
    icon: ''
  };

  const cardCount =
    sequence.items?.filter(i => i.__typename === 'Card').length || 0;
  let cardIndex = 1;

  const root = translate(sequence, item => {
    if (item.__typename === 'Text') {
      header.title = item.title || '';
      header.subtitle = item.subtitle || '';
      header.icon = item.icon || '';
    }

    if (item.__typename === 'Card') {
      cards.push(
        CardHelper(item as ItemOfType<'Card'>, {
          height: 'unset',
          width: '211px',
          padding: '0px',
          centerTitle: true,
          extraItems:
            cardIndex === cardCount
              ? []
              : [
                  {
                    id: `${item.id}.next`,
                    type: CAROUSEL_NEXT,
                    values: void {},
                    items: []
                  } as CarouselNextDefinition
                ]
        })
      );
      cardIndex++;
    }

    return null;
  });

  root.items.push({
    type: CAROUSEL,
    id: `${sequence.id}.carousel`,
    values: {
      variant: { _: 'stack', md: 'dynamic' },
      header: header
    },
    items: cards
  } as CarouselDefinition);

  return root;
};
